import { useEffect, useState } from 'react';
import { onFCP, onLCP } from 'web-vitals';

const useAnalyse = () => {
  const [analytics, setAnalytics] = useState<{ [name: string]: number }>();

  const sendToAnalytics = ({ name, value }: { name: string; value: number }) => {
    setAnalytics({ [name]: Math.round(value) });
  };

  useEffect(() => {
    onFCP(sendToAnalytics);
    onLCP(sendToAnalytics);
  }, []);

  return [analytics];
};

export default useAnalyse;
